module.exports = __webpack_public_path__ + "img/3_4.67e037db.png";